import type { RouteRecordRaw } from "vue-router"

const reportRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "reportList",
    component: () => import("@/templates/reports/ReportList.vue")
  },
  {
    path: "details/:reportId(\\d+)",
    name: "reportDetails",
    component: () => import("@/templates/reports/ReportDetails.vue"),
    meta: { breadcrumb: "general.view" }
  },
  {
    path: "create",
    name: "reportCreate",
    component: () => import("@/templates/reports/ReportCreate.vue")
  }
]

export default reportRoutes
